// Раскладка пунктов шапки: сколько их влезает в доступную ширину.
//
// Считать это CSS-порогом нельзя: нужная ширина зависит от роли (у владельца в
// шапке девять пунктов, у клиента восемь) и от длины ФИО в правом углу, поэтому
// один и тот же порог для одного человека велик, для другого мал. Здесь только
// арифметика — замеры делает TopBar.vue, а тесты бьют по чистой функции.
//
// gap — промежуток между соседями (gap-1 = 4px), moreWidth — ширина кнопки
// «Ещё ▾», которую надо зарезервировать, как только хоть один пункт вытеснен.
export function visibleCount(
  available: number,
  widths: number[],
  gap: number,
  moreWidth: number,
): number {
  if (widths.length === 0) return 0

  // Нулевые ширины = замера ещё не было (первый кадр, jsdom, скрытый header).
  // Прятать пункты по такому «замеру» нельзя: до первого ResizeObserver-события
  // шапка осталась бы пустой. Показываем всё, следующий кадр уточнит.
  if (widths.every((w) => w === 0)) return widths.length

  const total = widths.reduce((sum, w) => sum + w, 0) + gap * (widths.length - 1)
  if (total <= available) return widths.length

  const budget = available - moreWidth - gap
  let used = 0
  let count = 0
  for (const width of widths) {
    const next = used + width + (count > 0 ? gap : 0)
    if (next > budget) break
    used = next
    count += 1
  }
  return count
}

// Сколько ширины <nav> съедает его правая, невытесняемая часть: «Управление ▾» и
// владельческие ссылки. Ряд личных пунктов и правый блок — два соседа во flex с
// gap-1, и промежуток между ними есть всегда, даже когда правый блок пуст (у
// клиента). Без этого промежутка у клиента в окне шириной 4px (около 1100px у
// студента, 1135px у преподавателя) последний пункт влезал «по расчёту» и срезался.
// Обратная сторона: у клиента с «Ещё ▾» visibleCount вычитает gap перед кнопкой ещё
// раз, хотя он уже учтён здесь. В полосе шириной 4px клиент видит на пункт меньше,
// чем влезает; ошибка в безопасную сторону, срезов нет, поэтому оставлена.
export function reservedWidth(fixedWidths: number[], gap: number): number {
  return fixedWidths.reduce((sum, width) => sum + width + gap, 0) || gap
}
